import axios from 'axios';
import lockr from 'lockr';

const { REACT_APP_API_URL } = process.env;

const client = axios.create({
  baseURL: REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authHeaders = (restHeaders = {}) => {
  return {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
      ...restHeaders,
    },
  };
};

export const withParams = (url, params = {}) => {
  const paramsString = Object.entries(params)
    .reduce(
      (res, [key, value]) => [
        ...res,
        value
          ? Array.isArray(value)
            ? value.map((v) => [key, v].join('=')).join('&')
            : [key, value].join('=')
          : null,
      ],
      [],
    )
    .filter(Boolean)
    .join('&');

  if (!paramsString) {
    return url;
  }
  return `${url}?${paramsString}`;
};

export const secure = (query) => {
  const token = lockr.get('APP_AUTH_KEY');

  return {
    ...query,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      ...query?.headers,
    },
  };
};

export const backendError = (e) =>
  e?.data?.detail?.error ||
  e?.data?.detail?.[0]?.msg ||
  e?.data?.detail ||
  'Request error';

export default client;
